import { push } from "connected-react-router";
import { syncDirtyBudgets } from "containers/Budget/_actions";
import ReactGA from "react-ga4";

const actionType = {
    FRUIT_SAVE: "FRUIT_SAVE",
};
export default actionType;

export const saveFruit = (farmId, budgetId, blockId, fruit) => (dispatch) => {
    ReactGA.event({
        category: "Fruit",
        action: "Save",
    });
    dispatch({ type: actionType.FRUIT_SAVE, payload: { farmId, budgetId, blockId, fruit } });
    dispatch(push(`/app/farm/${farmId}/analysis/${budgetId}/crops`));
    dispatch(syncDirtyBudgets(budgetId));
};
